import React from "react";
import "./PrivacyPolicyPage.css";

const lastUpdated = new Date().toLocaleDateString("en-US", {
  year: "numeric",
  month: "numeric",
  day: "numeric",
});

function PrivacyPolicyPage() {
  return (
    <main className="tt-legal-wrap">
      <div className="tt-legal-card">
        <h1 className="tt-legal-title">Privacy Policy</h1>
        <p className="tt-legal-updated">Last Updated: {lastUpdated}</p>

        <section className="tt-legal-section">
          <h2>Information We Collect</h2>
          <p>We may collect personal information including but not limited to:</p>
          <ul>
            <li>Email addresses for newsletter subscriptions</li>
            <li>Anonymous usage data via Google Analytics</li>
            <li>Cookies to personalize content and ads</li>
          </ul>
        </section>

        <section className="tt-legal-section">
          <h2>How We Use Information</h2>
          <p>All data collection serves to:</p>
          <ol>
            <li>Improve user experience</li>
            <li>Display relevant advertisements</li>
            <li>Analyze site performance</li>
          </ol>
        </section>

        <section className="tt-legal-section">
          <h2>Third-Party Services</h2>
          <p>
            We use Google AdSense to serve ads, which uses cookies to personalize content.
            Users may opt out through Google's{" "}
            <a
              href="https://adssettings.google.com"
              target="_blank"
              rel="noreferrer"
              className="tt-legal-link"
            >
              Ad Settings
            </a>
            .
          </p>
        </section>
      </div>
    </main>
  );
}

export default PrivacyPolicyPage;
